import { apiRequest } from '@/shared/api/http'
import type {
  ChangeUserStatusRequest,
  CreateUserRequest,
  SetUserOverridesRequest,
  SetUserRolesRequest,
  UpdateUserRequest,
  UserDetailResponse,
  UserResponse,
  UserRoleAndPermissions,
} from '@/features/admin/domain/user.types'

const USERS_ENDPOINT = '/v1/users'

export const usersApi = {
  list: (signal?: AbortSignal) =>
    apiRequest<UserResponse[]>(USERS_ENDPOINT, { method: 'GET', signal }),

  getById: (id: number | string, signal?: AbortSignal) =>
    apiRequest<UserDetailResponse>(`${USERS_ENDPOINT}/${id}`, { method: 'GET', signal }),

  create: (body: CreateUserRequest) =>
    apiRequest<UserDetailResponse>(USERS_ENDPOINT, { method: 'POST', body }),

  update: (id: number | string, body: UpdateUserRequest) =>
    apiRequest<UserDetailResponse>(`${USERS_ENDPOINT}/${id}`, { method: 'PUT', body }),

  setRoles: (id: number | string, body: SetUserRolesRequest) =>
    apiRequest<UserDetailResponse>(`${USERS_ENDPOINT}/${id}/roles`, { method: 'PUT', body }),

  setStatus: (id: number | string, body: ChangeUserStatusRequest) =>
    apiRequest<UserDetailResponse>(`${USERS_ENDPOINT}/${id}/status`, { method: 'PUT', body }),

  delete: (id: number | string) =>
    apiRequest<void>(`${USERS_ENDPOINT}/${id}`, { method: 'DELETE' }),

  getPermissions: (id: number | string, signal?: AbortSignal) =>
    apiRequest<UserRoleAndPermissions>(`${USERS_ENDPOINT}/${id}/permissions`, { method: 'GET', signal }),

  setOverrides: (id: number | string, body: SetUserOverridesRequest) =>
    apiRequest<UserRoleAndPermissions>(`${USERS_ENDPOINT}/${id}/operations`, { method: 'PUT', body }),

  setAvatar: (id: number | string, avatar: string, signal?: AbortSignal) =>
    apiRequest<UserDetailResponse>(`${USERS_ENDPOINT}/${id}/avatar`, {
      method: 'PUT',
      body: { avatar },
      signal,
    }),

  deleteAvatar: (id: number | string, signal?: AbortSignal) =>
    apiRequest<void>(`${USERS_ENDPOINT}/${id}/avatar`, {
      method: 'DELETE',
      signal,
    }),
}

